import React from 'react'
import DefaultForm from '../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../ui/gov-actions'

const available = (record) => hasAvailableAction(record, 'cancel')

// eslint-disable-next-line react/display-name
const cancelForm = ({ gov_record }) => () => (
  <fieldset>
    Are you sure you want to cancel the Gov Enrolment for{' '}
    {gov_record.ChildFirstName || 'this child'}?
  </fieldset>
)

const apiEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/gov-enrolments/${gov_id}/cancel`

const formValue = 'cancel_enrolment'

// eslint-disable-next-line react/display-name
const actionForm = record => ({ handleSuccess }) => (
  <DefaultForm
    url={apiEndPoint(record)}
    value={formValue}
    formComponent={cancelForm(record)}
    label="Cancel Enrolment"
    handleSuccess={() =>
      handleSuccess({ [formValue]: 'This enrolment has been canceled' }, formValue)
    }
  />
)

const cancelEnrolment = ({ record }) =>
  available(record)
    ? {
      label: 'Cancel Enrolment',
      value: formValue,
      actionForm: actionForm(record),
    }
    : null

export default cancelEnrolment



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccms-gov-enrolments/cancel-enrolment.js